import { render, staticRenderFns } from "./Play_Size.vue?vue&type=template&id=3dbab156&scoped=true"
import script from "./Play_Size.vue?vue&type=script&lang=js"
export * from "./Play_Size.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbab156",
  null
  
)

export default component.exports